module.exports={
	"Form": "ObservationApprovalWorkflowEditManifest",
	"Scope": "ObservationApprovalWorkflow-Edit",
	"Descriptors":
	{
		"ObservationApprovalWorkflowDetails.IDObservationApprovalWorkflow":
		{
			"Name": "ID",
			"Hash": "ObsWfEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsWfEditIdentity",
				"Group": "ObsWfEditIdentity"
			}
		},
		"ObservationApprovalWorkflowDetails.Name":
		{
			"Name": "Transition Name",
			"Hash": "ObsWfEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ObsWfEditIdentity",
				"Group": "ObsWfEditIdentity"
			}
		},
		"ObservationApprovalWorkflowDetails.FromStatus":
		{
			"Name": "FromStatus",
			"Hash": "ObsWfEdit-FromStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "ObsWfEditConfig",
				"Group": "ObsWfEditConfig"
			}
		},
		"ObservationApprovalWorkflowDetails.ToStatus":
		{
			"Name": "ToStatus",
			"Hash": "ObsWfEdit-ToStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "ObsWfEditConfig",
				"Group": "ObsWfEditConfig"
			}
		},
		"ObservationApprovalWorkflowDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "ObsWfEdit-IDProject",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 4,
				"Section": "ObsWfEditConfig",
				"Group": "ObsWfEditConfig"
			}
		},
		"ObservationApprovalWorkflowDetails.EdgeOptions":
		{
			"Name": "Edge Options (JSON)",
			"Hash": "ObsWfEdit-EdgeOptions",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "ObsWfEditEdgeOptions",
				"Group": "ObsWfEditEdgeOptions"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsWfEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsWfEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Workflow Configuration",
			"Hash": "ObsWfEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Workflow Configuration",
					"Hash": "ObsWfEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Edge Options",
			"Hash": "ObsWfEditEdgeOptions",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Edge Options",
					"Hash": "ObsWfEditEdgeOptions",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
